import { CLOCKWISE, COUNTER_CLOCKWISE } from './Rhombus.js';

class Globals {

  static DEBUG = false;

  static CP_FIRST_ENUM = 0;
  static CP_DRAW = Globals.CP_FIRST_ENUM;
  static CP_STOP = Globals.CP_DRAW+1;
  static CP_RESET = Globals.CP_STOP+1;
  static CP_LAST_ENUM = Globals.CP_RESET;

  static NN_FIRST_ENUM = 0;
  static NN_CLOSEST_TO_CENTER = Globals.NN_FIRST_ENUM;
  static NN_RANDOM_INTERIOR = Globals.NN_CLOSEST_TO_CENTER+1;
  static NN_RANDOM = Globals.NN_RANDOM_INTERIOR+1;
  static NN_LAST_ENUM = Globals.NN_RANDOM;

  static SM_FIRST_ENUM = 0;
  static SM_INITIAL_STATE = Globals.SM_FIRST_ENUM+1;
  static SM_DRAWING = Globals.SM_INITIAL_STATE+1;
  static SM_MANUALLY_STOPPED = Globals.SM_DRAWING+1;
  static SM_FINISHED = Globals.SM_MANUALLY_STOPPED+1;
  static SM_STOPPED_DUE_TO_OVERLAP = Globals.SM_FINISHED+1;
  static SM_STOPPED_DUE_TO_HOLE = Globals.SM_STOPPED_DUE_TO_OVERLAP+1;
  static SM_INTERNAL_ERROR = Globals.SM_STOPPED_DUE_TO_HOLE+1;
  static SM_LAST_ENUM = Globals.SM_INTERNAL_ERROR+1;

  _direction = CLOCKWISE;
  _next_node_criteria = Globals.NN_CLOSEST_TO_CENTER;
  _control_panel_state = Globals.CP_STOP;
  _control_panel_state_listeners = [];
  _status_message = Globals.SM_INITIAL_STATE;
  _status_message_listeners = [];

  constructor() {
    if (Globals._instance) {
      return Globals._instance;
    }
    Globals._instance = this;
    this.reset();
  }

  reset() {
    this._direction = CLOCKWISE;
    this._next_node_criteria = Globals.NN_CLOSEST_TO_CENTER;
    this._control_panel_state = Globals.CP_STOP;
    for( let listener of this._control_panel_state_listeners) {
      listener(this._control_panel_state);
    }
    this._status_message = Globals.SM_INITIAL_STATE;
    for( let listener of this._status_message_listeners) {
      listener(this._status_message);
    }
  }

  get direction() { return this._direction; }
  set direction(direction) { 
    if ((direction != CLOCKWISE) && (direction != COUNTER_CLOCKWISE)) {
      throw `Invalid direction ${direction}`;
    }
    this._direction = direction; 
  }

  get next_node_criteria() { return this._next_node_criteria; }
  set next_node_criteria(value) {
    if ((value > Globals.NN_LAST_ENUM) || (value < Globals.NN_FIRST_ENUM)) {
      throw `Invalid next_node_criteria ${value}`;
    }
    this._next_node_criteria= value;
  }

  get cp_state() { return this._control_panel_state; }
  set cp_state(state) {
    if ((state > Globals.CP_LAST_ENUM) || (state < Globals.CP_FIRST_ENUM)) {
      throw `Invalid cp_state ${state}`;
    }
    this._control_panel_state = state;
    for( let listener of this._control_panel_state_listeners) {
      listener(state);
    }
  }
  register_cp_state_listener(listener) {
    this._control_panel_state_listeners.push(listener);
  }

  get status_message() { return this._status_message; }
  set status_message(message) {
    if ((message > Globals.SM_LAST_ENUM) || (message < Globals.SM_FIRST_ENUM)) {
      throw `Invalid status message ${message}`;
    }
    this._status_message = message;
    for( let listener of this._status_message_listeners) {
      listener(message);
    }
  }
  register_status_message_listener(listener) {
    this._status_message_listeners.push(listener);
  }
  
};

export { Globals };
